import { IFilterControl } from "../report-interface";

export class InputFilterModel implements IFilterControl {
    public name: string;
    public type: string = "TextFilter";
    public title: string;
    public sizeClass: string;
    public data: string[];
    public selectedData: string;
    public emptyText: string;

    constructor(name: string, title: string, selectedText: string, emptyText: string, type: string, sizeClass: string) {
        this.data = [selectedText];
        this.name = name;
        this.title = title;
        this.selectedData = selectedText;
        this.emptyText = emptyText;
        this.sizeClass = sizeClass;
        this.type = type;
    }

    public activate(item: string) {
        this.selectedData = item;
    }

    get selectedText() {
        return this.selectedData && this.selectedData.length > 0 ? this.selectedData : this.emptyText;
    }
}



// WEBPACK FOOTER //
// ./client/app/models/filterControls/input-filter-model.ts